import { gql } from '@apollo/client';
export const FIELDS_OF_STUDY_FIELDS = gql `
  fragment FieldsOfStudyFragment on FieldOfStudy {
    id
    category
    name
    contentId
    isActive
    createdAt
    updatedAt
    content {
      id
      clientId
      contentType
      code
      name
    }
  }
`;
export const FIELDS_OF_STUDY = gql `
  ${FIELDS_OF_STUDY_FIELDS}
  query FIELDS_OF_STUDY($spec: FieldOfStudySpec!) {
    fieldsOfStudy(spec: $spec) {
      total
      page
      pageSize
      items {
        ...FieldsOfStudyFragment
      }
    }
  }
`;
export const SAVE_FIELD_OF_STUDY = gql `
  mutation SAVE_FIELD_OF_STUDY($input: FieldOfStudyInput!) {
    saveFieldOfStudy(input: $input) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
